import React, { useRef } from 'react';
import MiracleListJ15 from '../../miracles/MiracleListJ15';

function PeopleGroupMiracles({ peopleGroupId }) {
  const filtersRef = useRef({ peopleGroupId });
  return <MiracleListJ15 filtersRef={filtersRef} queryId={peopleGroupId} />;
}

export default PeopleGroupMiracles;
